import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';

import { LoginComponent } from './modules/home/pages/login/login.component';
import { SignupComponent } from './modules/home/pages/signup/signup.component';
import { ForgotComponent } from './modules/home/pages/forgot/forgot.component';
import { AfterLoginComponent } from './modules/home/pages/afterlogin/afterlogin.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SidebarComponent } from './modules/home/pages/components/sidebar/sidebar.component';

import { AuthenticationService } from './core/authentication/Authentication.service';
import { AuthGuard } from './core/authentication/auth.guard';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { Module as StripeModule } from 'stripe-angular';
// Material
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomMaterialModule } from '../app/core/_helpers/CustomMaterialModule';
import { SubMenuComponent } from './shared/components/sub-menu/sub-menu.component';
import { DirectorysComponent } from './modules/access/directorys/directorys.component';
import { ThankYouPageComponent } from './modules/home/pages/thank-you-page/thank-you-page.component';
import { AccessComponent } from './modules/access/access.component';
import { WorkspaceSeetingsComponent } from './modules/workspace/workspace-seetings/workspace-seetings.component';
import { FullScreenOverlayComponent } from './shared/components/full-screen-overlay/full-screen-overlay.component';
import { ProfileSettingsComponent } from './modules/profile/profile-settings/profile-settings.component';
import { SettingsAllUserComponent } from './modules/profile/settings-all-user/settings-all-user.component';
import { UsersComponent } from './modules/profile/users/users.component';
import { AddUserComponent } from './modules/profile/add-user/add-user.component';
import { ChangePasswordComponent } from './modules/profile/change-password/change-password.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Language } from './core/_helpers/Language';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { SubMenuResultComponent } from './shared/components/sub-menu-result/sub-menu-result.component';
import { CallCenterComponent } from './modules/home/pages/call-center/call-center.component';
import { UpgradeComponent } from './modules/account/upgrade/upgrade.component';
import { PackComponent } from './modules/account/pack/pack.component';
import { PaymentmethodComponent } from './modules/account/paymentmethod/paymentmethod.component';
import { PlanesMembresiaComponent } from './modules/home/pages/planes-membresia/planes-membresia.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { CheckoutComponent } from './modules/home/pages/checkout/checkout.component';
import { LoaderService } from './core/_helpers/loader.service';
import { LoaderInterceptor } from './core/_helpers/LoaderInterceptor';
import { AgradecimientoComponent } from './modules/home/pages/agradecimiento/agradecimiento.component';
import { HttpErrorInterceptor } from './interceptor';
import { MessagesComponent } from './shared/components/messages/messages.component';
import { SearchService } from './core/Search/search.service';
import { SelectFiltreService } from './core/SelectFiltre/select-filtre.service';

import { url } from './shared/urls/url';
import { Plans } from './shared/urls/plans';
import { DatePipe } from '@angular/common';
import { DialogOverviewComponent } from './shared/components/modal/dialog-overview/dialog-overview.component';
import { BuildComponent } from './modules/home/pages/build/build.component';
import { ObjectivesComponent } from './modules/home/pages/build/objectives/objectives.component';
import { PeopleComponent } from './modules/home/pages/build/people/people.component';
import { HumanNetworkComponent } from './modules/home/pages/build/human-network/human-network.component';
import { ManageComponent } from './modules/home/pages/manage/manage.component';
import { SubMenuWelcomeComponent } from './shared/components/sub-menu-welcome/sub-menu-welcome.component';
import { ListActivitesComponent } from './modules/access/list-activites/list-activites.component';
import { TreeFlatOverviewExampleComponent } from './shared/components/tree-flat-overview-example/tree-flat-overview-example.component';
import { MapManagerComponent } from './modules/access/map-manager/map-manager.component';
import { ModalFormComponent } from './shared/components/modal-form/modal-form.component';
import { CytoscapeModule } from 'ngx-cytoscape';
import { Graph } from './test';
import { DifficultiesAgendaComponent } from './modules/home/pages/manage/difficulties-agenda/difficulties-agenda.component';
import { ProjectComponent } from './modules/access/project/project.component';
import { ObjectiveComponent } from './modules/access/objective/objective.component';
import { GroupComponent } from './modules/home/pages/build/group/group.component';
import { ModalFormObjectiveComponent } from './shared/components/modal-form-objective/modal-form-objective.component';
import { ModalFormMembersComponent } from './shared/components/modal-form-members/modal-form-members.component';
import { ModalFormActionComponent } from './shared/components/modal-form-action/modal-form-action.component';
import { CytoscapeComponent } from './core/_helpers/cytoscape';
import { EnablingActivitiesComponent } from './modules/home/pages/manage/enabling-activities/enabling-activities.component';
import { FunctionalMapComponent } from './modules/home/pages/manage/functional-map/functional-map.component';
import { Graph2 } from './test2';
import { PlanBillingComponent } from './modules/home/pages/plan-billing/plan-billing.component';
import { PlanComponent } from './modules/home/pages/plan-billing/plan/plan.component';
import { HistoryComponent } from './modules/home/pages/plan-billing/history/history.component';
import { MethodComponent } from './modules/home/pages/plan-billing/method/method.component';

// Add the Firebase services that you want to use

@NgModule({
  declarations: [ 
    CytoscapeComponent,   
    AppComponent,
    LoginComponent,
    AfterLoginComponent,
    SignupComponent,
    ForgotComponent,
    SidebarComponent,
    NavbarComponent,
    SubMenuComponent,
    DirectorysComponent,
    ThankYouPageComponent,
    AccessComponent,
    WorkspaceSeetingsComponent,
    FullScreenOverlayComponent,
    ProfileSettingsComponent,
    SettingsAllUserComponent,
    UsersComponent,
    AddUserComponent,
    ChangePasswordComponent,
    SubMenuResultComponent,
    CallCenterComponent,
    UpgradeComponent,
    PackComponent,
    PaymentmethodComponent,
    PlanesMembresiaComponent,
    LoaderComponent,
    CheckoutComponent,
    AgradecimientoComponent,
    MessagesComponent,
    DialogOverviewComponent,
    BuildComponent,
    ObjectivesComponent,
    PeopleComponent,
    HumanNetworkComponent,
    ManageComponent,
    SubMenuWelcomeComponent,
    ListActivitesComponent,
    TreeFlatOverviewExampleComponent,
    MapManagerComponent,
    ModalFormComponent,
    Graph,
    Graph2,
    DifficultiesAgendaComponent,
    ProjectComponent,
    ObjectiveComponent,
    GroupComponent,
    ModalFormObjectiveComponent,
    ModalFormMembersComponent,
    Graph,
    ModalFormActionComponent,
    EnablingActivitiesComponent,
    FunctionalMapComponent,
    PlanBillingComponent,
    PlanComponent,
    HistoryComponent,
    MethodComponent,
    ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    CytoscapeModule,
    StripeModule.forRoot(),
    NoopAnimationsModule,
    CustomMaterialModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http);
        },
        deps: [HttpClient]
      }
    }),
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    ReactiveFormsModule
  ],
  providers: [
    AuthenticationService,
    AuthGuard,
    url,
    Plans,
    SearchService,
    SelectFiltreService,
    Language,
    LoaderService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    }
    // { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    DialogOverviewComponent
  ],
})
export class AppModule {
}
